import React, { useEffect, useRef, useState } from "react";
import HeadCount from "./HeadCount";
import Funding from "./Funding";
import SEO from "./SEO";
import Glassdoor from "./Glassdoor";
import WebTraffic from "./WebTraffic";
import OnlineAd from "./OnlineAd";
import Summary from "./Summary";
import AlternateDomains from "./AlternateDomains";
import EmailIds from "./EmailIds";
import ContactNumbers from "./ContactNumbers";
import EmailPatterns from "./EmailPatterns";
import Specialties from "./Specialties";
import Tags from "./Tags";
import CrunchbaseCategories from "./CrunchbaseCategories";
import Keywords from "./Keywords";
import TechnologyUsed from "./TechnologyUsed";
import TechnologyUsedCategories from "./TechnologyUsedCategories";
import SicCodes from "./ SicCodes";
import NaicsCodes from "./ NaicsCodes";
// import { Tab, Tabs } from "react-tabs-scrollable";
// import "react-tabs-scrollable/dist/rts.css";
import { ChevronDown, ChevronLeft, ChevronRight, ChevronUp } from "lucide-react";
import ProductsAndServices from "./ProductsAndServices";
import FeaturesAndCapabilities from "./FeaturesAndCapabilities";
import ProgramsAndPartnerships from "./ProgramsAndPartnerships";
import { TabsContent, TabsList, TabsTrigger, Tabs } from "../../ui/tabs";
import { Numeral } from "react-numeral";
import NoInfo from "../NoInfo";
import G2 from "./G2";
import CRM from "../crm";
import Insights from "./Insights";
import Certifications from "./Certifications";
import Platforms from "./Platforms";
import TechStack from "./TechStack";
import LoaderInfinite from "./LoaderInfinite";
import ICP from "./ICP";
import CompanyContacts from "./CompanyContacts";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";
import Image from "../../Tags/Image";
import BasicDetails from "./BasicDetails";
import CompanySocialMedia from "./CompanySocialMedia";
import CompanyIcpExt from "./CompanyIcpExt";
import Hierarchy from "./Hierarchy";

export default function CompanyInfoCard({
  company,
  activeWorkspace,
  activeCrm = "",
  companyName,
  hasPendingEnrichmentAction = false,
  miniView,
  contactLinkedinUrl = "",
  insights = {},
  crmObjectsConfig = [],
  getActiveCRMID = null,
  source = "",
}) {
  const captureEvent = useCaptureEvent();
  const platformsToInclude = ["facebook", "youtube", "linkedin", "twitter"];
  const [currentTab, setCurrentTab] = useState("");
  const tabs = [
    {
      name: "Overview",
      label: "Overview",
      id: "overview",
      value: "overview",
      eventName: "EXC_Company_OverviewBtn",
    },
    // {
    //   name: "Insights",
    //   label: "Insights",
    //   id: "insights",
    //   value: "insights",
    // },
    {
      name: "Technologies",
      label: "Technologies",
      id: "technologies",
      value: "technologies",
      eventName: "EXC_Company_TechnologiesBtn",
    },
    // {
    //   name: "Product",
    //   label: "Product",
    //   id: "product",
    //   value: "product",
    //   eventName: "EXC_Company_ProductBtn",
    // },
    {
      name: "People",
      label: "People",
      id: "people",
      value: "people",
      eventName: "EXC_Company_PeopleBtn",
    },
    {
      name: "Search & Ads",
      label: "Search & Ads",
      id: "search_and_ads",
      value: "search_and_ads",
      eventName: "EXC_Company_Search&AdsBtn",
    },
    {
      name: "Reviews & PR",
      label: "Reviews & PR",
      id: "reviews_and_pr",
      value: "reviews_and_pr",
      eventName: "EXC_Company_Reviews&PRBtn",
    },
    // {
    //   name: "Hierarchy",
    //   label: "Hierarchy",
    //   id: "hierarchy",
    //   value: "hierarchy",
    //   eventName: "EXC_Company_HierarchyBtn",
    // },
  ];

  const [showMoreOverView, setShowMoreOverView] = useState(false);

  // handle active tab
  const [initActive, setInitActive] = useState("overview");
  const [activeTab, setActiveTab] = useState("");
  const onTabClick = (tab) => {
    const params = new URLSearchParams(window.location.search);
    params.set("tab", tab);
    window.history.replaceState({}, "", `${window.location.pathname}?${params}`);
  };

  useEffect(() => {
    if (window) {
      const params = new URLSearchParams(window.location.search);
      const tab = params.get("tab");
      if (tab) {
        if (tab === "contacts") {
          setCurrentParentTab("contacts");
        } else {
          setCurrentTab(tab);
          setInitActive("");
        }
      }
    }
  }, [window]);
  useEffect(() => {
    if (currentTab) {
      setActiveTab(currentTab);
    }
  }, [currentTab]);

  const shouldViewDetailsBeShown = () => {
    if (company) {
      if (company.additional_domains && company.additional_domains.length > 0) {
        return true;
      } else if (company.email_patterns && company.email_patterns.length > 0) {
        return true;
      } else if (company.crunchbase_categories && company.crunchbase_categories.length > 0) {
        return true;
      } else if (company.tags && company.tags.length > 0) {
        return true;
      } else if (company.keywords && company.keywords.length > 0) {
        return true;
      }
    } else {
      return false;
    }
  };

  const [currentParentTab, setCurrentParentTab] = useState("all");

  return (
    <>
      <div
        className={`${source !== "app" ? "p-4  border border-input  bg-background rounded-[12px]" : "border-b pb-5 mb-3"}`}
      >
        <div className="">
          <div className={`flex w-full mb-4 items-start ${source === "app" ? "justify-between" : ""}`}>
            <span className="inline-flex flex-col">
              <span
                className={`${
                  miniView ? "text-[20px]" : "text-[30px]"
                } text-gray-900 flex w-full items-center font-semibold leading-snug`}
              >
                {company?.logo ? (
                  <Image
                    src={company?.logo}
                    width={68}
                    height={68}
                    className="rounded-xl border border-gray-300 p-1 no-invert bg-white"
                    nobaseurl
                  />
                ) : (
                  <Image
                    src={"/images/ext/org.svg"}
                    width={58}
                    height={58}
                    className="rounded-xl border-gray-300  p-1 no-invert"
                  />
                )}
                <span className="ml-2">
                  <span className="leading-none">{company?.name ? company?.name : "-"}</span>
                  <a
                    href={`https://${company?.domain}`}
                    className="text-[16px] text-brand-700 block"
                    target="_blank"
                    onClick={() => {
                      captureEvent("EXC_Company_CompanyLink");
                    }}
                  >
                    {company?.domain ? company?.domain : "-"}
                  </a>
                </span>
              </span>
            </span>
            {!miniView && (
              <CRM
                activeWorkspace={activeWorkspace}
                recordData={company}
                activeCrm={activeCrm}
                type="company"
                className="mt-2 ml-5 relative inline-block"
                crmObjectsConfig={crmObjectsConfig}
                companyMiniView={false}
                getActiveCRMID={(id) => {
                  getActiveCRMID && getActiveCRMID(id);
                }}
                contentPosition={source === "app" ? "right" : ""}
              />
            )}
          </div>

          {!miniView && source !== "app" && <BasicDetails company={company} />}

          <div className="flex space-x-4 items-center">
            {/* {company?.social_media_urls &&
              Object.keys(company.social_media_urls)
                .filter((key) => platformsToInclude.includes(key))
                .map((key, index) => (
                  <a
                    key={index}
                    href={company.social_media_urls[key].url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img className="no-invert"
                      src={`images/social/${key}.svg`}
                      alt={`${key} logo`}
                      height={22}
                      style={{ maxHeight: 22 }}
                    />
                  </a>
                ))} */}
            {/* {contactLinkedinUrl && (
              <a
                href={contactLinkedinUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="no-invert"
                  src="images/ext/linkedin.svg"
                  alt={`logo`}
                  height={22}
                  style={{ maxHeight: 22 }}
                />
              </a>
            )} */}
            {source !== "app" && <CompanySocialMedia company={company} miniView={miniView} />}
          </div>
          {miniView && (
            <CRM
              activeWorkspace={activeWorkspace}
              recordData={company}
              activeCrm={activeCrm}
              type="company"
              crmObjectsConfig={crmObjectsConfig}
              getActiveCRMID={(id) => {
                getActiveCRMID && getActiveCRMID(id);
              }}
            />
          )}
        </div>
        {/* <div
          className={`${source !== "app" ? "bg-background rounded-xl overflow-hidden text-sm -mx-4 -mb-4 mt-3 space-x-1" : "-mb-5 mt-0 space-x-6"}`}
        >
          <span
            className={`${
              currentParentTab === "all"
                ? "inline-block py-3 border-b-[3px] border-b-brand-600 text-brand-700 cursor-pointer"
                : "inline-block py-3 border-b-[3px] border-b-transparent cursor-pointer"
            } ${source !== "app" ? "px-4" : ""}`}
            onClick={() => {
              onTabClick("");
              setCurrentParentTab("all");
            }}
          >
            All data
          </span>
          <span
            className={`${
              currentParentTab === "contacts"
                ? "inline-block py-3 border-b-[3px] border-b-brand-600 text-brand-700 cursor-pointer"
                : "inline-block py-3 border-b-[3px] border-b-transparent cursor-pointer"
            } ${source !== "app" ? "px-4" : ""}`}
            onClick={() => {
              setCurrentParentTab("contacts");
              onTabClick("contacts");
            }}
          >
            Contacts
          </span>
        </div> */}
      </div>

      {hasPendingEnrichmentAction && (
        <span className="flex items-center text-[14px] bg-background text-brand-700 border border-border p-4 rounded-[12px] space-x-2 mt-4">
          <div className="loader_circle mr-1"></div>
          <span>Fetching more data...</span>
        </span>
      )}
      {!miniView && (activeTab || initActive) && (
        <div className="">
          {currentParentTab === "contacts" && <CompanyContacts activeWorkspace={activeWorkspace} />}
          {currentParentTab === "all" && (
            <Tabs
              defaultValue={activeTab || initActive}
              className="w-full"
              onValueChange={(value) => {
                setActiveTab(value);
                setCurrentTab(value);
                console.log("value", value);
                onTabClick(value);
              }}
            >
              <div className={`${source === "app" ? "flex" : ""}`}>
                <div className={source === "app" ? "w-9/12" : ""}>
                  <TabsList className="my-3 company__data__tab flex w-full justify-center items-center h-min p-1 rounded-[8px] overflow-hidden border border-border bg-gray-50">
                    {tabs &&
                      tabs.length > 0 &&
                      tabs.map((tab) => (
                        <TabsTrigger
                          className="flex-1 company__data__tab__trigger rounded-md px-3 py-2.5 text-sm font-semibold ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-brand-700 dark:data-[state=active]:bg-brand-300 data-[state=active]:text-white data-[state=active]:shadow"
                          value={tab.value}
                          onClick={() => {
                            captureEvent(tab?.eventName);
                          }}
                        >
                          {tab.name}
                        </TabsTrigger>
                      ))}
                  </TabsList>
                  <TabsContent value="overview">
                    {company?.id && !hasPendingEnrichmentAction && source !== "app" && (
                      <ICP organizationId={company?.id} workspaceId={activeWorkspace?.id} />
                    )}
                    <div className="border rounded-[14px] overflow-hidden border-border  bg-background relative mt-4">
                      {company?.description && (
                        <Summary
                          data={{
                            description: company?.description,
                          }}
                        />
                      )}
                      {company && company.phone_numbers && company.phone_numbers.length > 0 && (
                        <ContactNumbers data={company.phone_numbers} />
                      )}
                      {company && company.email_addresses && company.email_addresses.length > 0 && (
                        <EmailIds data={company.email_addresses} />
                      )}
                      <div className="flex space-x-4 px-4 mb-4">
                        {company && company.naics_codes && company.naics_codes.length > 0 && (
                          <div className="w-6/12">
                            <NaicsCodes data={company.naics_codes} />
                          </div>
                        )}
                        {company && company.sic_codes && company.sic_codes.length > 0 && (
                          <div className="w-6/12">
                            <SicCodes data={company.sic_codes} />
                          </div>
                        )}
                      </div>
                      {showMoreOverView && (
                        <div className="space-y-4 px-4 mb-4">
                          {company && company.additional_domains && company.additional_domains.length > 0 && (
                            <div className="w-full">
                              {" "}
                              <AlternateDomains data={company.additional_domains} />
                            </div>
                          )}

                          {company && company.email_patterns && company.email_patterns.length > 0 && (
                            <div className="w-full">
                              {" "}
                              <EmailPatterns data={company.email_patterns} />
                            </div>
                          )}

                          {company &&
                            company.crunchbase_categories &&
                            company.crunchbase_categories.length > 0 && (
                              <div className="w-full">
                                <CrunchbaseCategories data={company.crunchbase_categories} />
                              </div>
                            )}

                          {company && company.tags && company.tags.length > 0 && <Tags data={company.tags} />}

                          {company && company.keywords && company.keywords.length > 0 && (
                            <Keywords data={company.keywords} />
                          )}
                        </div>
                      )}
                      {shouldViewDetailsBeShown() && (
                        <div className="px-4 mb-4">
                          <button
                            onClick={() => {
                              setShowMoreOverView(!showMoreOverView);
                              captureEvent("EXC_CompanyOverview_SummaryViewDetailsBtn");
                            }}
                            className="inline-flex items-center whitespace-nowrap text-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border bg-background text-gray-600 px-2 pl-4 py-2 justify-between h-9 rounded-[8px] font-semibold"
                          >
                            {!showMoreOverView ? "View" : "Hide"} Details{" "}
                            {showMoreOverView ? (
                              <ChevronUp width={16} className="ml-1" />
                            ) : (
                              <ChevronDown width={16} className="ml-1" />
                            )}
                          </button>
                        </div>
                      )}
                    </div>

                    {(company?.valuation ||
                      company?.funding?.recent_round?.amount_in_usd ||
                      company?.funding?.total_funding_amount ||
                      company?.revenue ||
                      (company?.stock_exchange && company?.stock_exchange !== "PRIVATE") ||
                      company?.stock_symbol) && (
                      <Funding
                        valuation={company?.valuation}
                        funding={company?.funding}
                        revenue={company?.revenue}
                        data={{
                          stock_exchange:
                            company?.stock_exchange === "PRIVATE" ? company?.name : company?.stock_exchange,
                          stock_symbol:
                            company?.stock_exchange === "PRIVATE"
                              ? company?.stock_exchange
                              : company?.stock_symbol,
                          stock_exchange_type: company?.stock_exchange,
                        }}
                      />
                    )}

                    {company && company.specialties && company.specialties.length > 0 && (
                      <Specialties data={company.specialties} />
                    )}
                  </TabsContent>
                  <TabsContent value="insights">{/* <Insights data={insights} /> */}</TabsContent>
                  <TabsContent value="technologies">
                    {company && company.id && (
                      <TechStack
                        workspaceId={activeWorkspace?.id}
                        organizationId={company?.id}
                        company={company}
                      />
                    )}
                  </TabsContent>
                  <TabsContent value="product">
                    {company &&
                      company.website_enrichment &&
                      company.website_enrichment.products &&
                      company.website_enrichment.products.length > 0 && (
                        <ProductsAndServices data={company.website_enrichment} />
                      )}

                    {company &&
                      company.website_enrichment &&
                      company.website_enrichment.available_platforms &&
                      company.website_enrichment.available_platforms.length > 0 && (
                        <Platforms data={company.website_enrichment.available_platforms} />
                      )}
                    {company && company.website_enrichment && (
                      <FeaturesAndCapabilities data={company.website_enrichment} />
                    )}
                    {company && company.website_enrichment && (
                      <ProgramsAndPartnerships data={company.website_enrichment} />
                    )}
                    {company &&
                      company.website_enrichment &&
                      company.website_enrichment.certifications &&
                      company.website_enrichment.certifications.length > 0 && (
                        <Certifications data={company.website_enrichment.certifications} />
                      )}
                    {company && !company.website_enrichment && <LoaderInfinite />}
                  </TabsContent>
                  <TabsContent value="people">
                    {company?.headcount && (
                      <HeadCount data={company?.headcount} employee_count={company?.employee_count} />
                    )}
                    {company && !company.headcount && <LoaderInfinite />}
                  </TabsContent>
                  <TabsContent value="search_and_ads">
                    {company?.website_traffic && <WebTraffic data={company?.website_traffic} />}
                    {company?.online_advertisement && <OnlineAd data={company?.online_advertisement} />}
                    {company?.search_engine_performance && <SEO data={company?.search_engine_performance} />}
                    {company &&
                      !company.website_traffic &&
                      !company?.online_advertisement &&
                      !company?.search_engine_performance && <LoaderInfinite />}
                  </TabsContent>
                  <TabsContent value="reviews_and_pr">
                    {company?.glassdoor && <Glassdoor data={company?.glassdoor} />}
                    {company?.g2 && <G2 data={company?.g2} />}
                    {company && !company.glassdoor && !company?.g2 && <LoaderInfinite />}
                  </TabsContent>
                  <TabsContent value="hierarchy">
                    <Hierarchy
                      workspaceId={activeWorkspace?.id}
                      organizationId={company?.id}
                      crmInfo={{
                        activeWorkspace: activeWorkspace,
                        activeCrm: activeCrm,
                        type: "company",
                        crmObjectsConfig: crmObjectsConfig,
                        source: "app",
                      }}
                    />
                  </TabsContent>
                </div>
                {source === "app" && (
                  <div className="w-3/12 pl-5">
                    <div className="bg-background p-4 border border-border rounded-lg mt-3">
                      <BasicDetails company={company} withIcons={true} />
                      <div className="mt-4">
                        <CompanySocialMedia company={company} />
                      </div>
                      <div className="mt-8 -mx-4 px-4 pt-2 border-t">
                        <CompanyIcpExt orgId={company?.id} workspaceId={activeWorkspace?.id} />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </Tabs>
          )}
        </div>
      )}
    </>
  );
}
